export default "__VITE_PUBLIC_ASSET__67c89978__"